var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[[_c('v-container',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_vm._v("Text")])],1)],1)],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }